import React from 'react';
import '../styles/Highlights.scss';
import AnimatedCounter from './AnimatedCounter';
import resort from '../assets/resort.png';
import rupee from '../assets/rupee.png';
import wellness from '../assets/wellness.png';

export default function Highlights() {
    return (
        <section id="highlights" className="highlights">
            <div className="container">
                <h2>Project Highlights</h2>
                <p className="lead">An exclusive collection of resort-style plots crafted for a serene lifestyle.</p>


                <div className="grid">
                    <article className="card">
                        <div className="icon">
                            <img src={resort} alt='resort-icon'></img>
                        </div>
                        <h3>10,000 sq.ft. Proposed Resort NA Plots <h4>(Possession of 9,000 sq. ft.)</h4> </h3>
                        <p>Spacious plots designed for privacy, luxury and long-term appreciation.</p>
                        <AnimatedCounter from={0} to={9000} suffix={' sq.ft'} />
                    </article>


                    <article className="card">
                        <div className="icon">
                             <img src={rupee} alt='rupee-icon'></img>
                        </div>
                        <h3>Pre-Launch Price</h3>
                        <p>At an introductory rate designed to offer strong ROI.</p>
                        {/* <AnimatedCounter from={0} to={550} prefix={'₹'} suffix={'/sq.ft'} /> */}
                    </article>


                    <article className="card">
                        <div className="icon">
                             <img src={wellness} alt='wellness-icon'></img>
                        </div>
                        <h3>4 Acres of Resort (Paid Amenities)</h3>
                        <p>Yoga lawns, natural pools and curated for experiences.</p>
                        <AnimatedCounter from={0} to={4} suffix={' acres'} decimals={1} />
                    </article>
                </div>
            </div>
        </section>
    );
}